import React, { useEffect } from 'react';
import { View } from 'react-native';
import { useRouter } from 'expo-router';
import { FullScreenLoader } from '@/shared/components/FullScreenLoader';
import AdminDashboard from '@/components/admin/AdminDashboard';
import { EmptyState } from '@/components/admin/AdminUI';
import { useIsAdmin } from '@/shared/hooks/useIsAdmin';
import { ROUTES } from '@/shared/constants/routes';
import { white } from '@/shared/styles/colors';

export default function AdminScreen() {
  const router = useRouter();
  const { isAdmin, isLoading, error, refetch } = useIsAdmin();

  // The server enforces access on every query; this just keeps others out of the page
  useEffect(() => {
    if (!isLoading && !isAdmin && !error) {
      router.replace(ROUTES.SESSIONS.path);
    }
  }, [isAdmin, isLoading, error, router]);

  if (isAdmin) {
    return <AdminDashboard />;
  }

  // Couldn't tell (not a "no"), so offer a retry instead of sending them away
  if (error && !isLoading) {
    return (
      <View style={{ padding: 24, backgroundColor: white, flex: 1 }}>
        <EmptyState
          title="Couldn’t check access"
          body="We couldn’t confirm you can use the dashboard. This is usually a brief hiccup."
          onRetry={() => refetch()}
        />
      </View>
    );
  }

  return <FullScreenLoader />;
}
